import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconEqualsNot(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.8682 5.49613C17.1423 5.01661 16.9757 4.40575 16.4961 4.13174C16.0166 3.85774 15.4058 4.02433 15.1318 4.50385L13.134 7.99999H5C4.44772 7.99999 4 8.4477 4 8.99999C4 9.55227 4.44772 9.99999 5 9.99999H11.9911L9.70539 14H5C4.44772 14 4 14.4477 4 15C4 15.5523 4.44772 16 5 16H8.56253L7.13176 18.5038C6.85775 18.9834 7.02434 19.5942 7.50386 19.8682C7.98338 20.1422 8.59423 19.9756 8.86824 19.4961L10.866 16H19C19.5523 16 20 15.5523 20 15C20 14.4477 19.5523 14 19 14H12.0089L14.2946 9.99999H19C19.5523 9.99999 20 9.55227 20 8.99999C20 8.4477 19.5523 7.99999 19 7.99999H15.4375L16.8682 5.49613Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
